"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var MediaManagerImage_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/MediaManagerImage"));

var PictureFrame_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/PictureFrame"));

var em_1 = tslib_1.__importDefault(require("polished/lib/helpers/em"));

var prop_types_1 = tslib_1.__importDefault(require("prop-types"));

var react_1 = tslib_1.__importStar(require("react"));

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var Backdrop = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 0;\n  transition: opacity 0.2s;\n  background-image: linear-gradient(rgba(0, 0, 0, 0) 20%, rgba(0, 0, 0, 0.8));\n  opacity: 1;\n"], ["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 0;\n  transition: opacity 0.2s;\n  background-image: linear-gradient(rgba(0, 0, 0, 0) 20%, rgba(0, 0, 0, 0.8));\n  opacity: 1;\n"])));
var StyledPictureFrame = styled_components_1["default"](PictureFrame_1["default"])(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var StyledMediaManagerImage = styled_components_1["default"](MediaManagerImage_1["default"])(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  background-size: cover !important;\n"], ["\n  width: 100%;\n  height: 100%;\n  background-size: cover !important;\n"])));
var Title = styled_components_1["default"].header(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  color: #fff;\n  bottom: 0.5em;\n  right: 0.5em;\n  left: 0.5em;\n\n  display: block;\n  display: -webkit-box;\n  font-size: ", ";\n  font-weight: 500;\n  line-height: 1.2;\n  max-width: 100%;\n  max-height: ", ";\n  margin-bottom: 0;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  position: absolute;\n  color: #fff;\n  bottom: 0.5em;\n  right: 0.5em;\n  left: 0.5em;\n\n  display: block;\n  display: -webkit-box;\n  font-size: ", ";\n  font-weight: 500;\n  line-height: 1.2;\n  max-width: 100%;\n  max-height: ", ";\n  margin-bottom: 0;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])), function (_a) {
  var containerWidth = _a.containerWidth;
  return containerWidth < 800 ? em_1["default"](30) : em_1["default"](45);
}, em_1["default"](70));

var Item =
/** @class */
function (_super) {
  tslib_1.__extends(Item, _super);

  function Item() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Item.prototype.render = function () {
    var _a = this.props,
        title = _a.title,
        maxWidth = _a.maxWidth,
        picture = _a.picture;
    return react_1["default"].createElement(StyledPictureFrame, {
      width: 16,
      height: 9
    }, picture && react_1["default"].createElement(StyledMediaManagerImage, {
      picture: picture,
      naturalWidth: maxWidth,
      naturalHeight: (9 / 16 * maxWidth).toFixed(),
      script: "media"
    }), react_1["default"].createElement(Backdrop, null), react_1["default"].createElement(Title, {
      containerWidth: maxWidth
    }, title));
  };

  return Item;
}(react_1.PureComponent);

Item.propTypes = {
  title: prop_types_1["default"].string,
  maxWidth: prop_types_1["default"].number.isRequired,
  picture: prop_types_1["default"].shape({})
};
Item.defaultProps = {
  title: '',
  picture: null
};
exports["default"] = Item;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;